@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.fullwidth {
  width: 100%;
}

.home {
  padding-top: 3.4rem;
  background-color: $white;
  margin-left: auto;
  margin-right: auto;

  @include mobile {
    width: 100%;
    padding-top: 0;
  }

  h1 {
    font-weight: 550;
    color: #555555;
    text-align: center;
    margin-bottom: 2rem;
    margin-top: 2rem;
  }

  @include mobile {
    margin-bottom: 0;
  }
}

.fullwidth {
  width: 100%;
}

.banner {
  width: 100%;
}

.wrapper {
  .action-content {
    .logo-white {
      margin-top: 2.5rem;
      margin-bottom: 1.25rem;
      width: 7.5rem;
      height: 7.5rem;
      align-self: center;
      display: none;

      @include widescreen {
        display: block;
      }
    }

    .logo-black {
      margin-top: 3rem;
      margin-bottom: 1rem;
      width: 7.5rem;
      height: 7.5rem;
      align-self: center;
      display: none;

      @include touch {
        display: block;
        height: auto;
        width: 30%;
      }

      @include desktop-only {
        display: block;
      }
    }

    .checkbox-container {
      margin-top: 1.5rem;

      @include mobile {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }

      .checkbox {
        display: block;
        @include mobile {
          display: none;
        }
      }

      .mobile-only {
        display: none;
        @include mobile {
          display: block;
        }
      }
    }

    .button-wrapper {
      margin-top: 2rem;

      @include mobile {
        margin-top: .75rem;
      }

      button {
        width: 140px;
        font-size: 0.8125rem;
        border-radius: 5px;
        height: auto;
      }
    }

    .required-info-container {
      .required-info {
        margin-top: 1.25rem;
        margin-bottom: 0;

        @include mobile {
          color: $grey;
          padding-left: 1.5rem;
          padding-right: 1.5rem;
        }
      }
    }
  }
}

.flex {
  display: flex;

  @include mobile {
    flex-wrap: wrap;
  }
}

.checkbox-container {
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;

  @include mobile {
    flex-wrap: wrap;
    margin-top: 1rem;
  }

  .privacy {
    color: white;
    font-size: 0.85rem;
    font-weight: 300;
    line-height: 1.125rem;
    max-width: 500px;

    a {
      color: white;
    }

    @include mobile {
      color: #888888;

      a {
        color: #888888;
      }
    }
  }
}

.space {
  min-width: 4%;
}

.column {
  margin-top: 3.125rem;
  flex-grow: 1;
  flex-basis: 0;

  @include mobile {
    min-width: 100%;
    margin-top: 1.5rem;
  }
}

.ny-yt-player {
  width: 100%;
  min-height: 40vh;
  padding: 4%;
}

.button-wrapper {
  margin-top: 1.6rem;

  display: flex;
  align-content: flex-end;

  button {
    width: 140px;
    height: auto;
    font-size: 0.8125rem;
  }

  @include mobile {
   // margin-top: 2rem;
    //margin-bottom: 1.5rem;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.button-divider {
  width: 1.25rem;

  @include mobile {
    width: 100%;
    height: .5rem
  }
}

.button-space {
  flex-grow: 1;
  @include touch {
    display: none;
  }
}

.red {
  font-weight: 900;
  color: $ny-red;
}

.info-wrapper {
  width: 100%;
  text-align: center;
  margin: 1rem auto;
}

.terms {
  text-align: center;
  font-size: 0.8rem;
  padding-bottom: 80px;
}

.action-container {
  position: relative;

  @include mobile {
    margin-bottom: 1rem;
  }

  .background-image {
    height: 470px;
    width: 100%;
    display: block;

    +.overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      opacity: 0.75;
      background-color: $black;

      @include touch {
        display: none;
      }


      @include desktop-only {
        display: none;
      }
    }

    @include touch {
      display: none;
    }


    @include desktop-only {
      display: none;
    }
  }
}

.action-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include touch {
    position: static;
  }

  @include desktop-only {
    position: static;
  }


  .logo-white {
    margin-top: 3rem;
    margin-bottom: 1.6rem;
    align-self: center;
    display: none;

    @include widescreen {
      display: block;
    }
  }

  .logo-black {
    margin-top: 3rem;
    margin-bottom: 1.6rem;
    align-self: center;
    display: none;

    @include touch {
      display: block;
      height: auto;
      width: 30%;
    }

    @include desktop-only {
      display: block;
    }
  }

  .infoText {
    width: 56%;
    text-align: center;
    height: auto;
    font-size: 0.875rem;
    letter-spacing: 0.025rem;
    line-height: 1.125rem;
    font-weight: 400;
    color: #d6d6d6;

    @include touch {
      color: $grey;
      width: 80%;
    }

    @include desktop-only {
      color: $grey-text;
    }
  }

  .required-info-container {
    .required-info {
      color: #d6d6d6;
      font-size: 0.75rem;
      line-height: 0.75rem;
      font-weight: 300;
      margin-top: 1.5rem;
      margin-bottom: 1rem;
    }
  }

}

.center-helper{
  flex-grow: 1;
}

.vertical-spacer {

  padding-bottom: 1.5rem;

}

.fixed-bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 60px;
  background: white;
  box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.19), 0px -6px 6px rgba(0, 0, 0, 0.23);
}

